
export const DOM_EVENT: string = "$event";

export const TARGET_ELEMENT: string = "$event.target";

export const TARGET_ELEMENT_VALUE: string = "$event.target.value";

export const BLUR_EVENT: string = "blur";

export const FOCUS_EVENT: string = "focus";

export const FOCUSIN_EVENT: string = "focusin";

export const FOCUSOUT_EVENT: string = "focusout";

export const MOUSEOVER_EVENT: string = "mouseover";

export const MOUSEOUT_EVENT: string = "mouseout";

export const MOUSELEAVE_EVENT: string = "mouseleave";

export const CLICK_EVENT: string = "click";

export const KEYUP_EVENT: string = "keyup";

export const KEYDOWN_EVENT: string = "keydown";

export const KEYPRESS_EVENT: string = "keypress";

export const CHANGE_EVENT: string = "change";

export const ELEMENT_VALUE: string = "value";

export const BLANK_STRING = '';

export const PLACEHOLDER = 'placeholder';

export const TABINDEX = 'tabindex';

